import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ModelStatusPagamento } from '../models/status-pagamento.model';
import { ApiInfocapebsVindiService } from './api-infocapebs-vindi.service';
import { ApiUsuarioService } from './api-usuario.service';

import { ApiCotacoesService } from 'src/app/services/api-cotacoes.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BaseService } from './base.service';
import *  as  dataPlanos from 'src/docs/planos-v2.json';
import { ApiSeguradoraService } from './api-seguradora.service';
import { ConfSeguradora } from 'src/app/models/conf-seguradora.model';
import *  as  linksVideos from 'src/docs/links-videos.json';
import * as Moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
	providedIn: 'root'
})
export class ControllerStatusService {

	STATUS = new ModelStatusPagamento();
	// private ListaPlanos = (dataPlanos as any).default;
	private ListaPlanos: any = {};
	linksVideos: any = {};
	private interval: any;
	private timerInterval = 1000 * 30;

	moment = Moment;
	dataAtual = this.moment().locale('pt-br');
	confsSeguradoras = [];
	confsSeguradorasInv = [];
	checkPeloLoginOuInicial: boolean = false;
	faturaAvulsa: boolean = false;
	status: BehaviorSubject<any>;
	statusTransacao: 'success' | 'aguardando' | 'free' | 'error' | 'teste' = 'aguardando';
	mensagemPagamento;
	erroCriarAssinaturaSubject = new BehaviorSubject(false);
	erroCheckAguardarSubject = new BehaviorSubject(false);
	cartaoInvalido: boolean = false;
	isUpgrade: boolean = false;
	assinaturaUpgrade;
	dadosAssinaturaDBApice;
	planos;
	statusPagamentoNovoSubject = new BehaviorSubject('aguardando')
	statusUpgradeSubject = new BehaviorSubject('aguardando')
	temPerfil = false;
	cobranca_id;
	ENV = environment;
	qrCodeSubject = new BehaviorSubject('');
	formaPagamento;
	dataFimQrCode;
	faturaCode;
	primeiraContratacaoPendente = false;
	valorCredito = 0;
	valorTotalPago = 0;
	valorMigracao = 0;
	diasMostrarAlertaRenovacaoAntecipada = 7;
	renovacao = false;
	renovacaoManual = false;
	assinaturaAntiga = false;
	gateway_token;
	upgradeConfirmado = false
	


	statusPagamentoNovo = this.statusPagamentoNovoSubject.asObservable();
	statusUpgrade = this.statusUpgradeSubject.asObservable();
	qrCode = this.qrCodeSubject.asObservable();
	erroCriarAssinatura = this.erroCriarAssinaturaSubject.asObservable();
	erroCheckAguardar = this.erroCheckAguardarSubject.asObservable();
	

	constructor(private snack: MatSnackBar, private apiEbs: ApiInfocapebsVindiService, private apiUsuario: ApiUsuarioService, private base: BaseService, private apiCotacoes: ApiCotacoesService, private apiSeguradora: ApiSeguradoraService, private http: HttpClient) {
		this.status = new BehaviorSubject<any>('');
	}

	// FAZER O CHECK QUANDO
	// 1 - CONTRATOU/RENOVOVOU UMA ASSINATURA
	// 2 - ADICIONOU MAIS USUÁRIOS

	// REF2 - COMO É POR CARTÃO SERIA INTERESSANTE FAZER A CHECAGEM DURANTE UNS 5 MINUTOS
	// SE NESSE TEMPO NÃO TIVER RETORNO É PORQUE TEVE ALGUM PROBLEMA COM A FORMA DE PAGAMENTO
	// NESTE CASO AVISAR COM UMA MENSAGEM (SNACK) E NA TELA DO PLANO QUE HOUVE FALHA NO PAGAMENTO
	// ASSIM O CLIENTE PODERA EDITAR OS SEUS DADOS E TENTAR NOVAMENTE
	// SENDO ASSIM TEREMOS QUE CANCELAR ESSA "ASSINATURA PENDENTE" E CRIAR UMA NOVA COM OS DADOS DO PERFIL DE PAGAMENTO NOVO

	getJsonPlanos() {
		try {
			this.ListaPlanos = (dataPlanos as any).default;
			this.planos = this.ListaPlanos;

		} catch (error) {
			console.log("Erro ao pegar planos do docs");
			console.log(error);
		}
	}

	getJsonPlanos_old() {
		this.http.get(window.location.origin + '/docs/planos.json', this.base.getHeaders()).toPromise().then((data) => {
			this.ListaPlanos = data;
			this.planos = data;
		}).catch(err => {
			console.log(err);
			//caso falhe ele vai buscar diretamente dos assets, neste caso se houver atualização do json no s3 pode ser que não o pegue até o cloudfront recachear
			this.ListaPlanos = (dataPlanos as any).default;
			this.planos = this.ListaPlanos;
		})
	}

	getJsonLinksVideos() {
		this.http.get(window.location.origin + '/docs/links-videos.json', this.base.getHeaders()).toPromise().then((data) => {
			this.linksVideos = data;
		}).catch(err => {
			console.log(err);
			//caso falhe ele vai buscar diretamente dos assets, neste caso se houver atualização do json no s3 pode ser que não o pegue até o cloudfront recachear
			this.linksVideos = (linksVideos as any).default;
		})
	}

	async buscaListaPlanos() {
		this.planos = this.ListaPlanos;
	}
	async buscaDadosAssinaturaDBApice(buscarNovamente = false) {
		try {
			let ret: any = await this.apiEbs.dadosAssinaturaDBApice(buscarNovamente);
			if (ret?.assinaturaId?.length) {

				ret.assinaturaVigente = ret?.assinaturaId.find(assinatura => assinatura.situacao == 1);
				ret.assinaturaFutura = ret?.assinaturaId.find(assinatura => assinatura.situacao == 2);
				if (this.isUpgrade) {
					this.isUpgrade = ret?.assinaturaFutura ? true : false;
					if (!this.isUpgrade && this.dadosAssinaturaDBApice?.assinaturaFutura && this.dadosAssinaturaDBApice?.assinaturaFutura?.id !== ret?.assinaturaVigente?.id) {
						this.atualizaErroCriarAssinatura(true);
					} else if (!this.isUpgrade) {
						this.upgradeConfirmado = true;
					} else if (this.isUpgrade && this.dadosAssinaturaDBApice?.assinaturaFutura?.pagamento?.status == 'paid') {
						this.atualizaErroCriarAssinatura(true);
					}
				} else {
					this.isUpgrade = ret?.assinaturaFutura ? true : false;
				}
				if (!ret.assinaturaVigente && !ret.assinaturaFutura) {
					if (!Object.keys(ret.assinaturaId[0]).includes('situacao')) {
						this.assinaturaAntiga = true;
					} else {
						this.assinaturaAntiga = false;
					}
				} else {
					this.assinaturaAntiga = false;
				}
				if (this.dadosAssinaturaDBApice?.assinaturaVigente) {
					if (!ret.assinaturaVigente) {
						this.atualizaErroCriarAssinatura(true);
					} else {
						this.atualizaErroCriarAssinatura(false);
					}
				}
				this.valorTotalPago = ret.assinaturaVigente?.pagamento?.valorPago;
				ret.assinaturaId = !ret.assinaturaVigente && !this.assinaturaAntiga ? [] : ret.assinaturaId;
				this.dadosAssinaturaDBApice = ret;
				this.renovacaoManual = this.renovacaoManual || ret?.assinaturaVigente?.renovacaoManual || (ret?.assinaturaVigente?.pagamento?.status == 'waiting' && this.moment(ret?.assinaturaVigente?.start_at).startOf('day') > this.moment(ret.licenca).startOf('day')) ? true : false;
			}
			return ret
		} catch (error) {
			console.log('dados assinatura Apice', error);
			throw error;
		}
	}

	// [
	// 	{"id":"73830292000163-APC-MENSAL-1605731475726","vigente":true,"status":1},
	// 	{"id":"73830292000163-APC-MENSAL-1605795788205","vigente":false,"status":2}
	// ]

	// APÓS RETORNAR O ARRAY DE ASSINATURAS IDS, DEVO PEGAR E VERIFICAR OS DOIS INDEX DO ARRAY.
	// SE ELES ESTIVEREM O MESMO STATUS 1 E VIGENTE TRUE E MESMO ID, ESTE É O PLANO VIGENTE
	// CASO OS DOIS INDEX TENHA DIFERENCA NO STATUS, VIGENTE E ID, QUER DIZER QUE ELE FEZ UPGRADE E ACONTECEU ALGO

	contCheck = 0;
	async checkStatusPagamento(initial?, verificacao?, telaContratacao?) {
		let ret
		let repetindo = false;
		ret = await this.buscaDadosAssinaturaDBApice(true);
		if (ret?.assinaturaVigente || this.assinaturaAntiga) {
			let ret1
			if (!ret.assinaturaVigente?.pagamento || telaContratacao || this.assinaturaAntiga) {
				try {
					do {
						await new Promise<void>(resolve => setTimeout(async () => {
							if (repetindo) ret = await this.buscaDadosAssinaturaDBApice(true);
							ret1 = await this.checkingAll();
							resolve();
						}, 3000));
						repetindo = true;
						this.contCheck++;
					} while (this.verificaContinuaChecando(ret, ret1));
					if (this.contCheck >= 10) {
						this.atualizaErroCriarAssinatura(true);
						let ret2: any = await this.apiEbs.checkStatusPagamento(true, null, true);
						ret = await this.buscaDadosAssinaturaDBApice(true);
						ret1 = await this.checkingAll();
					}

				} catch (error) {
					return ret1;
				}
				this.contCheck = 0;
				return ret1;
			}
		} else {
			this.contCheck = 0;
			return false;
		}
	}

	verificaContinuaChecando(ret, ret1) {
		if (this.erroCriarAssinaturaSubject.value) {
			return false;
		} else if (!ret.assinaturaFutura && !ret1.cobranca_id && ret?.assinaturaId.length > 0 && this.contCheck < 10) {
			return true;
		} else if (ret.assinaturaFutura && !ret.assinaturaFutura?.pagamento?.status && !this.upgradeConfirmado && this.formaPagamento != 'PIX' && this.contCheck < 10) {
			return true;
		} else if (ret.assinaturaFutura && !ret.assinaturaFutura?.pagamento?.qrcode_original_path && !this.upgradeConfirmado && this.formaPagamento == 'PIX' && this.contCheck < 10) {
			return true;
		}
		return false;

	}

	contagem = 0;
	async checkingAll() {
		try {
			let ret: any = await this.apiEbs.checkStatusPagamento(true);
			if (ret?.status) {
				let retChecado = await this.verificaStatusRetorno(ret)
				if (retChecado) {
					this.valorCredito = this.upgradeConfirmado ? this.valorCredito : ret.valoresPagamento.valorCredito
					this.primeiraContratacaoPendente = ((this.dadosAssinaturaDBApice?.assinaturaVigente?.pagamento?.status == "pending" || this.dadosAssinaturaDBApice?.assinaturaVigente?.pagamento?.status == "waiting" || this.dadosAssinaturaDBApice?.assinaturaVigente?.pagamento?.status == "error" || this.dadosAssinaturaDBApice?.assinaturaVigente?.pagamento?.status == "rejected") && this.moment(this.dadosAssinaturaDBApice.assinaturaVigente.start_at).startOf('day') <= this.moment().startOf('day') || this.primeiraContratacaoPendente);
					this.valorMigracao = ret.valoresPagamento.valorMigracao;
					await this.atualizaStatusTransacao(retChecado);
				}
			}
			return ret
		} catch (error) {
			console.log('erro ao checar status pagamento', error);
		}
	}

	async verificaStatusRetorno(ret) {
		if (ret?.meioPagamento?.toUpperCase() === 'PIX') {
			if (ret?.status == 'paid') {
				this.formaPagamento = "PIX";
				delete ret?.qrcode_original_path;
				delete ret?.prazo;
			} else if (ret?.qrcode_original_path && (this.moment(this.dataFimQrCode).isBefore(this.moment(ret?.prazo)) || !this.dataFimQrCode)) {
				this.qrCodeSubject.next(ret.qrcode_original_path);
				this.gateway_token = ret?.token_transaction;
				this.formaPagamento = "PIX";
				this.dataFimQrCode = ret?.prazo;
			} else {
				this.gateway_token = ret?.token_transaction;
				this.formaPagamento = "PIX";
			}
		} else if (ret?.meioPagamento == "cash") {
			this.formaPagamento = "PIX";
		} else if (ret?.meioPagamento == '' && !this.temPerfil) {
			this.formaPagamento == "PIX"
		} else {
			this.formaPagamento = "CREDITO";
		}
		return ret;

	}

	async cancelarAssinatura(assinatura) {
		// try {
		// 	let ret: any = await this.apiEbs.cancelaAssinatura(assinatura, true);
		// 	if (ret?.message == 'Sucesso!') {
		// 		console.log('assinatura cancelada');
		// 	}
		// } catch (error) {
		// 	console.log('erro ao cancelar assinatura', error);
		// } finally {
		// 	this.checandoStatusPagamento(true);
		// }

	}

	// checkStatusTransacao() {
	// 	let credenciais = this.apiUsuario.getCredenciais();
	// 	let status = credenciais;
	// 	let faturaPendente = false;
	// 	let faturaPendenteError = false;
	// 	let pendentes = credenciais.faturaAvulsas;

	// 	if (pendentes.length) {
	// 		let lastIndex = pendentes.length - 1;
	// 		if (pendentes[lastIndex].status == 1) faturaPendente = false;
	// 		if (pendentes[lastIndex].status == 2) faturaPendente = true;
	// 		if (pendentes[lastIndex].status == 3) faturaPendenteError = true;
	// 	}
	// 	this.atualizaStatusTransacao({ status: status.statusCorretora }, faturaPendente, faturaPendenteError);
	// }

	adicionarUsuariosNaoPagos = [];
	async atualizaStatusTransacao(status) {
		if (this.isUpgrade) {
			this.assinaturaUpgrade = this.dadosAssinaturaDBApice.assinaturaFutura;
			let statusUpgrade = status.status == "paid" || status.status == 'success' ? 'success' : status.status == 'fail' || status.status == 'rejected' || status.status == 'error' || status.status == 'canceled' ? 'error' : 'aguardando';
			this.dadosAssinaturaDBApice.assinaturaVigente.status
			this.atualizaStatusUpgrade(statusUpgrade);
		} else {
			this.atualizaStatusUpgrade('aguardando');
		}
		let statusVerificado = status.status;
		if (statusVerificado == "paid" || statusVerificado == 'success') {
			this.statusTransacao = 'success';
			this.mensagemPagamento = status.mensagemCartao ?? status.mensagemPagamento;
			this.cartaoInvalido = false;
			// if (this.isUpgrade) this.upgradeConfirmado = true;
			this.qrCodeSubject.next('');
			this.cobranca_id = status.cobranca_id;
			this.atualizaStatusPagamentoNovo('success');
			this.faturaAvulsa = false;
			this.apiUsuario.atualizaKeysPagamento();
			if (this.assinaturaUpgrade?.status != 2 || !status.isUpgrade) clearInterval(this.interval);
		} else if (statusVerificado == 'pending' || statusVerificado == 'processing' || statusVerificado == 'waiting' || statusVerificado == 'rejected') {
			if (this.formaPagamento == 'CREDITO') {
				this.statusTransacao = 'error';
				this.atualizaStatusPagamentoNovo('error');
				await this.apiUsuario.atualizaKeysPagamento();
				this.mensagemPagamento = status.mensagemCartao ?? status.mensagemPagamento;
				this.cartaoInvalido = true;
				this.cobranca_id = status.cobranca_id;
				this.faturaAvulsa = false;
			} else if (this.formaPagamento == 'PIX' && status.qrcode_original_path) {
				this.mensagemPagamento = status.mensagemCartao ?? status.mensagemPagamento;
				this.cartaoInvalido = false;
				this.statusTransacao = 'aguardando';
				this.cobranca_id = status.cobranca_id;
				this.atualizaStatusPagamentoNovo('aguardando');
			} else {
				this.statusTransacao = 'error';
				this.atualizaStatusPagamentoNovo('error');
				this.mensagemPagamento = status.mensagemCartao ?? status.mensagemPagamento;
				this.cartaoInvalido = false;
				this.cobranca_id = status.cobranca_id;
				this.faturaAvulsa = false;
			}
		} else if (statusVerificado == this.STATUS.TESTE) {
			this.statusTransacao = 'teste';
			await this.apiUsuario.atualizaKeysPagamento();
			this.atualizaStatusPagamentoNovo('teste');
		} else if (statusVerificado == 'fail' || statusVerificado == 'rejected' || statusVerificado == 'error' || statusVerificado == 'canceled') {
			this.statusTransacao = this.formaPagamento == 'PIX' ? 'aguardando' : 'error';
			this.atualizaStatusPagamentoNovo(this.formaPagamento == 'PIX' ? 'aguardando' : 'error');
			await this.apiUsuario.atualizaKeysPagamento();
			this.mensagemPagamento = status.mensagemCartao ?? status.mensagemPagamento;
			this.cartaoInvalido = true;
			this.cobranca_id = status.cobranca_id;
			this.faturaAvulsa = false;
			if (this.assinaturaUpgrade?.status != 2 || !status.isUpgrade) clearInterval(this.interval);
		} else {
			this.statusTransacao = 'teste';
			this.atualizaStatusPagamentoNovo('teste');
			await this.apiUsuario.atualizaKeysPagamento();
		}
		// for (let fat of status.todasFaturas) {
		// 	if (fat.status == "pending" && !this.adicionarUsuariosNaoPagos.find(f => f.cobranca_id == fat.cobranca_id) && fat.cobranca_id != status.cobranca_id) {
		// 		let obj = {
		// 			"cobranca_id": fat.cobranca_id,
		// 			"gateway_token": fat.camposPagamento?.token_transaction ?? null,
		// 			"max_days": fat.camposPagamento?.max_days_to_keep_waiting_payment ?? null,
		// 			"qr_code": fat.camposPagamento?.qrcode_original_path ?? null,
		// 		}
		// 		this.adicionarUsuariosNaoPagos.push(obj);
		// 	}
		// }
		return status
	}

	stopInterval() {
		this.checkPeloLoginOuInicial = false;
		clearInterval(this.interval);
	}

	buscaQtdeCalculos(dtStartSubscribe) {
		return this.apiCotacoes.buscaQtdeNegociosMes(dtStartSubscribe);
	}

	verificaStatus() {
		let result: any = this.apiUsuario.verificaLicenca();
		if (result?.prazoHoras >= 0 && !result.periodoTeste) {
			return false;
		}
		return true;
	}

	pixUsuarioAdicional = false;
	contaRequisicao = 0
	async checkUsuarioAdicional(faturaCode, pix?) {
		if (pix) this.pixUsuarioAdicional = true;
		try {
			let status: any = await this.apiEbs.checkStatusPagamento(false, faturaCode);
			if (status.status == 'rejected') {
				this.statusTransacao = 'error';
				this.atualizaStatusPagamentoNovo('error');
				this.mensagemPagamento = 'Houve um erro no pagamento, favor verificar os dados e tentar novamente.';
				this.cartaoInvalido = true;
			} else if (status.status == 'success' || status.status == 'paid') {
				this.statusTransacao = 'success';
				this.atualizaStatusPagamentoNovo('success');
			}
			else {
				this.atualizaStatusPagamentoNovo('aguardando');
				this.statusTransacao = 'aguardando';
				if (!pix && this.contaRequisicao < 15) {
					await new Promise<void>(resolve => setTimeout(async () => {
						let ret = await this.checkUsuarioAdicional(faturaCode);
						resolve();
					}, 3000));
					this.contaRequisicao++;
				} else {
					return status
				}
			}
			return status
		} catch (error) {
			console.log('erro ao checar status pagamento do usuário adicional', error);
			try {
				await new Promise(resolve => setTimeout(resolve, 3000));
				await this.checkUsuarioAdicional(faturaCode);
			} catch (error) {
				console.log('erro ao checar status pagamento do usuário adicional', error);
			}
		}

	}

	async verificaPermissoesParceiro(rota?): Promise<boolean> {
		let planoUsuario: any;
		let rotasBolqueadas = ['/contratar', '/config-corretora', '/config-usuarios', '/config-preferencias', '/config-coberturas', '/config-ramos', '/faturas-nfe', '/corretor-digital']
		let rotasBolqueadasAdmin = ['/contratar', '/faturas-nfe', '/corretor-digital']
		if (!this.apiUsuario.assinaturaUser && !this.assinaturaBkp) {
			this.assinaturaBkp = await this.apiUsuario.getAssinaturaId();
		}

		let assinatura = this.apiUsuario.assinaturaUser || this.assinaturaBkp;
		if (assinatura && assinatura?.assinatura) {
			planoUsuario = this.planos.produtos[assinatura.assinatura.produtos[0].produtoId];
		}
		if (planoUsuario && (!this.apiUsuario.getCredenciais()?.admin && rotasBolqueadas.includes(rota) || this.apiUsuario.getCredenciais()?.admin && rotasBolqueadasAdmin.includes(rota))){
			return planoUsuario.code != "APC-TOTAL-VIP";
		}
		return true;

	}

	assinaturaBkp: any;
	async verificaPermissoes(rota?) {

		let planoUsuario: any;
		let dtStartSubscribe;
		if (this.apiUsuario.primeiroTeste) {
			await this.apiUsuario.getAssinaturaId();
			this.apiUsuario.primeiroTeste = false;
		}
		/** SE FOR CORRETORA COM PARCERIA ALLIANZ */
		if (this.apiUsuario.getCredenciais()?.root) {
			return true;
		} else if (this.apiUsuario.getCredenciais()?.parceiro_id == "APC-INFOCAP-BASICO") {
			await this.apiUsuario.getAssinaturaId();
			dtStartSubscribe = this.apiUsuario.assinaturaUser.dataStartAss
			// planoUsuario = this.planos.filter(plano => plano.codeVindi === "APC-INFOCAP-BASICO")[0];
			planoUsuario = this.planos.produtos['APC-INFOCAP-BASICO'];
		} else {
			if (this.apiUsuario.assinaturaUser) {
				this.assinaturaBkp = this.apiUsuario.assinaturaUser;
				dtStartSubscribe = this.apiUsuario.assinaturaUser.dataStartAss
				// planoUsuario = this.planos.filter(plano => plano.codeVindi === this.apiUsuario.assinaturaUser?.assinatura?.produtos[0].produtoId)[0];
				planoUsuario = this.planos.produtos[this.apiUsuario.assinaturaUser?.assinatura?.produtos[0].produtoId]
			} else {
				if (this.assinaturaBkp) {
					dtStartSubscribe = this.assinaturaBkp.dataStartAss
					// planoUsuario = this.planos.filter(plano => plano.codeVindi === this.assinaturaBkp?.assinatura?.produtos[0].produtoId)[0];
					planoUsuario = this.planos.produtos[this.assinaturaBkp?.assinatura?.produtos[0].produtoId]
				} else {
					await this.apiUsuario.getAssinaturaId();
					dtStartSubscribe = this.apiUsuario.assinaturaUser.dataStartAss
					// planoUsuario = this.planos.filter(plano => plano.codeVindi === this.apiUsuario.assinaturaUser?.assinatura?.produtos[0].produtoId)[0];
					planoUsuario = this.planos.produtos[this.apiUsuario.assinaturaUser?.assinatura?.produtos[0].produtoId]
				}

			}


			///precisei adicionar este bloco para contar os dia a a partir do primeiro dia do mes

			var data = new Date();
			data.setDate(1)
			data.setHours(0);
			data.setMinutes(0);
			dtStartSubscribe = data;

		}

		let regexResults = /resultados/gm
		let regexAuto = /auto/gm
		try {
			if (rota === '/lista-tarefas') {
				return planoUsuario.funcionalidades.controleDeTarefas.status === 1 ? true : false;
			} else if (rota === '/cotacao/auto/formulario' || rota === "/cotacao/auto/enviarCalculo") {
				let qtdeCalc: any = await this.buscaQtdeCalculos(dtStartSubscribe);

				// if(planoUsuario.funcionalidades.auto.status === 1 && qtdeCalc.total > planoUsuario.qtdeCalcsMes && planoUsuario.qtdeCalcsMes != 'ilimitado'){
				// 	let msg = 'Limite de cálculos ultrapassados no mês ' + qtdeCalc.total  + '/' + planoUsuario.qtdeCalcsMes;
				// 	this.snack.open(msg)
				// }
				return planoUsuario.funcionalidades.auto.status === 1 && (qtdeCalc.total <= planoUsuario.qtdeCalcsMes || planoUsuario.qtdeCalcsMes === 'ilimitado') ? true : false;
			} else if (rota === '/cotacao/caminhao/formulario' || rota === "/cotacao/caminhao/enviarCalculo") {
				let qtdeCalc: any = await this.buscaQtdeCalculos(dtStartSubscribe);
				return planoUsuario.funcionalidades.caminhao.status === 1 && (qtdeCalc.total <= planoUsuario.qtdeCalcsMes || planoUsuario.qtdeCalcsMes === 'ilimitado') ? true : false;
			} else if (rota === '/cotacao/motocicleta/formulario' || rota === "/cotacao/motocicleta/enviarCalculo") {
				let qtdeCalc: any = await this.buscaQtdeCalculos(dtStartSubscribe);
				return planoUsuario.funcionalidades.moto.status === 1 && (qtdeCalc.total <= planoUsuario.qtdeCalcsMes || planoUsuario.qtdeCalcsMes === 'ilimitado') ? true : false;
			} else if (rota === '/cotacao/residencial/formulario') {
				let qtdeCalc: any = await this.buscaQtdeCalculos(dtStartSubscribe);
				return planoUsuario.funcionalidades.residencial.status === 1 && (qtdeCalc.total <= planoUsuario.qtdeCalcsMes || planoUsuario.qtdeCalcsMes === 'ilimitado') ? true : false;
			} else if (rota === '/cotacao/empresarial/formulario') {
				let qtdeCalc: any = await this.buscaQtdeCalculos(dtStartSubscribe);
				return planoUsuario.funcionalidades.empresarial.status === 1 && (qtdeCalc.total <= planoUsuario.qtdeCalcsMes || planoUsuario.qtdeCalcsMes === 'ilimitado') ? true : false;
			} else if (rota === '/cotacao/vida/formulario') {
				let qtdeCalc: any = await this.buscaQtdeCalculos(dtStartSubscribe);
				return planoUsuario.funcionalidades.vida.status === 1 && (qtdeCalc.total <= planoUsuario.qtdeCalcsMes || planoUsuario.qtdeCalcsMes === 'ilimitado') ? true : false;
			}  else if (rota === '/cotacao/vida_global/formulario') {
				let qtdeCalc: any = await this.buscaQtdeCalculos(dtStartSubscribe);
				return planoUsuario.funcionalidades.vidaGlobal.status === 1 && (qtdeCalc.total <= planoUsuario.qtdeCalcsMes || planoUsuario.qtdeCalcsMes === 'ilimitado') ? true : false;
			} else if (rota === '/cotacao/acidentes_pessoais/formulario') {
				let qtdeCalc: any = await this.buscaQtdeCalculos(dtStartSubscribe);
				return planoUsuario.funcionalidades.acidentesPessoais.status === 1 && (qtdeCalc.total <= planoUsuario.qtdeCalcsMes || planoUsuario.qtdeCalcsMes === 'ilimitado') ? true : false;
			} else if (rota === '/cotacao/viagem/formulario') {
				let qtdeCalc: any = await this.buscaQtdeCalculos(dtStartSubscribe);
				return planoUsuario.funcionalidades.viagem.status === 1 && (qtdeCalc.total <= planoUsuario.qtdeCalcsMes || planoUsuario.qtdeCalcsMes === 'ilimitado') ? true : false
			} else if (rota === '/cotacao/condominio/formulario') {
				let qtdeCalc: any = await this.buscaQtdeCalculos(dtStartSubscribe);
				return planoUsuario.funcionalidades.condominio.status === 1 && (qtdeCalc.total <= planoUsuario.qtdeCalcsMes || planoUsuario.qtdeCalcsMes === 'ilimitado') ? true : false;
			} else if (rota === '/funil-de-vendas' || rota === '/lista-negocios') {
				return planoUsuario.funcionalidades.funilDeVendas.status === 1 ? true : false;
			} else if (rota === '/corretor-digital') {
				return planoUsuario.funcionalidades.corretorDigital.status === 1 ? true : false;
			} else if (rota === '/parcelas') {
				return planoUsuario.funcionalidades.parcelasVencidas.status === 1 ? true : false;
			} else if (rota === '/documentos') {
				return planoUsuario.funcionalidades.buscaDeDocsEmitidos.status === 1 ? true : false;
			} else if (rota === '/fechamento-de-negocio') {
				return planoUsuario.funcionalidades.fechamentoDeNegocio.status === 1 ? true : false;
			} else if (rota === '/orcamento' || rota === '/preview-orcamento') {
				return planoUsuario.funcionalidades.orcamentoCompleto.status === 1 ? true : false;
			} else if (planoUsuario.code == 'APC-BASICO' && !regexResults.test(rota) && !regexAuto.test(rota)) {
				return false;
			} else {
				return true;
			}
		} catch (error) {
			console.log("Ocorreu um erro ao buscar assinatura no vindi ou retorno está lento", error);
			return false
		}

	}

	async verificaPermissoesFuncts(funcionalidade) {
		let planoUsuario: any;
		try {
			if (this.verificaStatus() === false && this.apiUsuario.getCredenciais()?.parceiro_id != "APC-INFOCAP-BASICO") {
				if (this.apiUsuario.assinaturaUser) {
					this.assinaturaBkp = this.apiUsuario.assinaturaUser;
					// planoUsuario = this.planos.filter(plano => plano.codeVindi === this.apiUsuario.assinaturaUser?.assinatura?.produtos[0].produtoId)[0];
					planoUsuario = this.planos.produtos[this.apiUsuario.assinaturaUser?.assinatura?.produtos[0].produtoId];
				} else {
					if (this.assinaturaBkp) {
						// planoUsuario = this.planos.filter(plano => plano.codeVindi === this.assinaturaBkp?.assinatura?.produtos[0].produtoId)[0];
						planoUsuario = this.planos.produtos[this.assinaturaBkp?.assinatura?.produtos[0].produtoId];
						this.apiUsuario.assinaturaUser = this.assinaturaBkp;
					} else {
						await this.apiUsuario.getAssinaturaId();
						this.assinaturaBkp = this.apiUsuario.assinaturaUser;
						// planoUsuario = this.planos.filter(plano => plano.codeVindi === this.apiUsuario.assinaturaUser?.assinatura?.produtos[0].produtoId)[0];
						planoUsuario = this.planos.produtos[this.apiUsuario.assinaturaUser?.assinatura?.produtos[0].produtoId];
					}
				}
				// planoUsuario = this.planos.produtos[this.apiUsuario.assinaturaUser?.assinatura?.produtos[0].produtoId];
			} else if (this.apiUsuario.getCredenciais()?.parceiro_id == "APC-INFOCAP-BASICO") {
				// planoUsuario = this.planos.filter(plano => plano.codeVindi == 'APC-INFOCAP-BASICO')[0]
				planoUsuario = this.planos.produtos['APC-INFOCAP-BASICO']

				/** SE FOR CORRETORA COM PARCERIA ALLIANZ */
			}
			if (this.apiUsuario.getCredenciais()?.root) {
				return true;
			} else if (funcionalidade === 'pdf_orçamentoS') {
				return this.verificaStatus() || planoUsuario.funcionalidades.orcamentoSimplificado.status === 1 ? true : false;
			} else if (funcionalidade === 'orcamentoCompleto') {
				return this.verificaStatus() || planoUsuario.funcionalidades.orcamentoCompleto.status === 1 ? true : false;
			} else if (funcionalidade === 'simuladorDeComissoes') {
				return this.verificaStatus() || planoUsuario.funcionalidades.simuladorDeComissoes.status === 1 ? true : false;
			} else if (funcionalidade === 'estatisticaVeiculos') {
				return this.verificaStatus() || planoUsuario.funcionalidades.estatisticaVeiculos.status === 1 ? true : false;
			} else if (funcionalidade === 'parcelasVencidas') {
				return this.verificaStatus() || planoUsuario.funcionalidades.parcelasVencidas.status === 1 ? true : false;
			} else if (funcionalidade === 'buscaDeDocsEmitidos') {
				return this.verificaStatus() || planoUsuario.funcionalidades.buscaDeDocsEmitidos.status === 1 ? true : false;
			} else if (funcionalidade === 'relacoesDeComissoes') {
				return this.verificaStatus() || planoUsuario.funcionalidades.relacoesDeComissoes.status === 1 ? true : false;
			} else if (funcionalidade === 'assinaturaDigital') {
				return this.verificaStatus() || planoUsuario.funcionalidades.assinaturaDigital.status === 1 ? true : false;
			} else if (funcionalidade === 'renovacoesResgates') {
				return this.verificaStatus() || planoUsuario.funcionalidades.renovacoesResgates.status === 1 ? true : false;
			} else if (funcionalidade === 'gestaoDeComissoes') {
				return this.verificaStatus() || planoUsuario.funcionalidades.gestaoDeComissoes.status === 1 ? true : false;
			} else if (funcionalidade === 'gestaoFinanceira') {
				return this.verificaStatus() || planoUsuario.funcionalidades.gestaoFinanceira.status === 1 ? true : false;
			} else if (funcionalidade === 'repasseProdutores') {
				return this.verificaStatus() || planoUsuario.funcionalidades.repasseProdutores.status === 1 ? true : false;
			} else if (funcionalidade === 'centralDeNegocios') {
				return this.verificaStatus() || planoUsuario.funcionalidades.centralDeNegocios.status === 1 ? true : false;
			} else if (funcionalidade === 'mapasEstatisticos') {
				return this.verificaStatus() || planoUsuario.funcionalidades.mapasEstatisticos.status === 1 ? true : false;
			} else if (funcionalidade === 'gestaDeSinistros') {
				return this.verificaStatus() || planoUsuario.funcionalidades.gestaDeSinistros.status === 1 ? true : false;
			} else if (funcionalidade === 'suporteVideo') {
				return this.verificaStatus() || planoUsuario.funcionalidades.suporteVideo.status === 1 ? true : false;
			} else if (funcionalidade === 'suporteTicket') {
				return this.verificaStatus() || planoUsuario.funcionalidades.suporteTicket.status === 1 ? true : false;
			} else if (funcionalidade === 'suporteChat') {
				return this.verificaStatus() || planoUsuario.funcionalidades.suporteChat.status === 1 ? true : false;
			} else if (funcionalidade === 'suporteEmail') {
				return this.verificaStatus() || planoUsuario.funcionalidades.suporteEmail.status === 1 ? true : false;
			} else if (funcionalidade === 'suporteFone') {
				return this.verificaStatus() || planoUsuario.funcionalidades.suporteFone.status === 1 ? true : false;
			} else if (funcionalidade === 'whatsapp') {
				return this.verificaStatus() || planoUsuario.funcionalidades.suporteWhatsApp.status === 1 ? true : false;
			} else if (funcionalidade === 'novoNegocioFB') {
				return this.verificaStatus() || planoUsuario.code != 'APC-BASICO' ? true : false;
			} else {
				return true;
			}
		} catch (error) {
			return false;
		}

	}

	async buscaSeguradoras() {
		this.confsSeguradoras = [];
		this.confsSeguradorasInv = [];
		try {
			let _confsSeguradoras: any = await this.apiSeguradora.buscaConfSeguradoras();

			for (let configs of _confsSeguradoras) {
				let confSeguradora = new ConfSeguradora(configs);
				// não exibe a Itaú
				if (confSeguradora.seguradoraId != 15) {
					if (confSeguradora && confSeguradora.ativo && confSeguradora.credenciaisValidas) {
						this.confsSeguradoras.push(confSeguradora);
					}
					else if (!confSeguradora.credenciaisValidas && confSeguradora.ativo) {
						this.confsSeguradorasInv.push(confSeguradora);
					}
				}
			}


		} catch (error) {
			console.error("Falha ao buscar configurações de seguradora", error);
		}
	}

	atualizaStatusPagamentoNovo(status) {
		this.statusPagamentoNovoSubject.next(status)
	}
	atualizaStatusUpgrade(status) {
		this.statusUpgradeSubject.next(status)
	}

	atualizaErroCriarAssinatura(value: boolean) {
		this.erroCriarAssinaturaSubject.next(value)
	}
}

